import { render, staticRenderFns } from "./IconSvgBuy.vue?vue&type=template&id=41d49f61&scoped=true&"
import script from "./IconSvgBuy.vue?vue&type=script&lang=js&"
export * from "./IconSvgBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d49f61",
  null
  
)

export default component.exports